<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <!-- 主表单区域 -->
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="8">
            <a-form-item :label="$t('label.contracts')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select :placeholder="$t('label.pleaseSelectTheContractNumber')" :disabled="conCodeDisable"  @change="conCodeChanged" v-decorator="['code',validatorRules.code]">
                <a-select-option
                  v-for="item in conCodeList"
                  :key="item.code"
                  :value="item.code">
                  {{ item.code }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="甲方公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['paCompanyCode']" :trigger-change="true" dictCode="" placeholder="请选择甲方公司"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="乙方养户" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['pbFarmerCode']" :trigger-change="true" dictCode="" placeholder="请选择乙方养户"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="合同名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['name']" placeholder="请输入合同名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.cooperationModel')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['cooperMode']" :trigger-change="true" dictCode="" :placeholder="$t('label.pleaseSelectTheCooperationMode')" />
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="合同类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['conType']" :trigger-change="true" dictCode="" placeholder="请选择合同类型"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.feedingLot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['breedBatchCode']" :placeholder="$t('label.pleaseEnterTheFeedingLot')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="合同签订日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date disabled placeholder="请选择合同签订日期" v-decorator="['partyBSignDate']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="合同生效日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date disabled placeholder="请选择合同生效日期" v-decorator="['conStartDate']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="合同终止日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date disabled placeholder="请选择合同终止日期" v-decorator="['conEndDate']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="签订地点" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled  v-decorator="['conAddress']" placeholder="请输入签订地点"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="行业" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['conIndustry']" placeholder="请输入行业"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="部门" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['conIndustryDepart']" placeholder="请输入部门"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="录入人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['conReporter']" :trigger-change="true" dictCode="" placeholder="请选择录入人"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="币种" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['conCurrency']" placeholder="请输入币种"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="本位币" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['conFunctionalCurrency']" placeholder="请输入本位币"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="折本汇率" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['conDiscountRate']" placeholder="请输入折本汇率" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="养户管理员" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['pbFarmerName']" :trigger-change="true" :dictCode="dictPbFarmerName" placeholder="请选择养户管理员"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="养殖品类" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['breedClassCode']" :trigger-change="true" dictCode="sys_category,name,code,pid=(select id from sys_category where code='A01' AND name = '物种分类')" placeholder="请选择养殖品类"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="养殖品系" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['breedVarietyCode']" :trigger-change="true" :dictCode="dictBreedVarietyCode" placeholder="请选择养殖品系"/>
            </a-form-item>
          </a-col>

          <a-col :span="8" >
            <a-form-item label="服务组" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['conServiceGroup']" :trigger-change="true" :dictCode="dictPaDeptCode" placeholder="请选择服务组"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
      <!-- 子表单区域 -->
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane tab="出栏" :key="refKeys[0]" :forceRender="true">
        <column-info-form ref="columnInfoForm" @validateError="validateError" :disabled="formDisabled"></column-info-form>
      </a-tab-pane>
      <a-tab-pane tab="耗用信息" :key="refKeys[1]" :forceRender="true">
        <consume-info-form ref="consumeInfoForm" @validateError="validateError" :disabled="formDisabled"></consume-info-form>
      </a-tab-pane>
      <a-tab-pane tab="费用项" :key="refKeys[2]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[2]"
          :loading="viewEfsStlFeeTable.loading"
          :columns="viewEfsStlFeeTable.columns"
          :dataSource="viewEfsStlFeeTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="false"/>
      </a-tab-pane>
      <a-tab-pane tab="补贴项" :key="refKeys[3]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[3]"
          :loading="viewEfsStlSubsidyTable.loading"
          :columns="viewEfsStlSubsidyTable.columns"
          :dataSource="viewEfsStlSubsidyTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="false"/>
      </a-tab-pane>
      <a-tab-pane tab="利润" :key="refKeys[4]" :forceRender="true">
        <profit-info-form ref="profitInfoForm" @validateError="validateError" :disabled="formDisabled"></profit-info-form>
      </a-tab-pane>
      <a-tab-pane tab="备注" :key="refKeys[5]" :forceRender="true">
        <efs-stl-settle-detail-form ref="efsStlSettleDetailForm" @validateError="validateError" :disabled="formDisabled"></efs-stl-settle-detail-form>
      </a-tab-pane>

    </a-tabs>
  </a-spin>
</template>

<script>

  import pick from 'lodash.pick'
  import { httpAction, getAction } from '@/api/manage'
  import { FormTypes,getRefPromise } from '@/utils/JEditableTableUtil'
  import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import ColumnInfoForm from './ColumnInfoForm.vue'
  import ConsumeInfoForm from './ConsumeInfoForm.vue'
  import ProfitInfoForm from './ProfitInfoForm.vue'
  import EfsStlSettleDetailForm from './EfsStlSettleDetailForm.vue'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import { getSettleByConCode,getCurrentUser } from '@/api/api'
  export default {
    name: 'EfsStlSettleForm',
    mixins: [JEditableTableMixin],
    components: {
      JFormContainer,
      ColumnInfoForm,
      ConsumeInfoForm,
      ProfitInfoForm,
      EfsStlSettleDetailForm,
      JDate,
      JDictSelectTag,
    },
    data() {
      return {
        conCodeDisable:false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        conCodeList:[],//合同
        validatorRules: {
          code: {
            rules: [
              { required: true, message: this.$t('label.pleaseSelectContract')},
            ]
          },
        },
        refKeys: ['columnInfo',  'viewEfsStlSubsidy', 'viewEfsStlFee','consumeInfo', 'profitInfo', 'efsStlSettleDetail', ],
        tableKeys:['viewEfsStlSubsidy', 'viewEfsStlFee',],
        activeKey: 'efsStlSettleDetail',
        // 结算单详情
        columnInfoTable: {
          loading: false,
          dataSource: [],
          columns: [
          ]
        },
        consumeInfoTable: {
          loading: false,
          dataSource: [],
          columns: [
          ]
        },
        // view_efs_stl_subsidy
        viewEfsStlSubsidyTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '类别',
              key: 'itemText',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '项目',
              key: 'archName',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '金额',
              key: 'unitPrice',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
          ]
        },
        // view_efs_stl_fee
        viewEfsStlFeeTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '类别',
              key: 'itemText',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '项目',
              key: 'archName',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '金额',
              key: 'unitPrice',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
          ]
        },
        profitInfoTable: {
          loading: false,
          dataSource: [],
          columns: [
          ]
        },
        efsStlSettleDetailTable: {
          loading: false,
          dataSource: [],
          columns: [
          ]
        },

        url: {
          add: "/settleList/efsStlSettle/add",
          edit: "/settleList/efsStlSettle/edit",
          queryById: "/settleList/efsStlSettle/queryById",
          queryByConCode: '/newContractManage/efsMdContract/queryByConCode',
          efsStlSettleDetail: {
            list: '/settleList/efsStlSettle/queryEfsStlSettleDetailByMainId'
          },
          viewEfsStlSubsidy: {
            list: '/settleList/efsStlSettle/queryViewEfsStlSubsidyByMainId'
          },
          viewEfsStlFee: {
            list: '/settleList/efsStlSettle/queryViewEfsStlFeeByMainId'
          },
        },
          dictBreedVarietyCode: "",
          dictPbFarmerName: "3",
          dictPaDeptCode: "1",
      }
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：false流程表单 true普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
        getCurrentUser().then((res) => {
            if (res.success) {
                this.dictPaDeptCode = "sys_depart,depart_name,org_code,org_code like '" + res.result.orgCode + "*' and org_category='2' and del_flag='0'";
                this.dictPbFarmerName = "view_efs_user_depart,realname,username,org_code like '" + res.result.orgCode + "*' and post = '2' and org_category='2' and del_flag='0'";
            }
        });
    },
    methods: {
      add () {
        getSettleByConCode({contractCode: ""}).then((res) => {
          if (res.success) {
            this.conCodeList = res.result.newEfsMdContract;
          }
        });
      },
      addBefore(){
        this.form.resetFields()
        this.$refs.columnInfoForm.clearFormData()
        this.$refs.consumeInfoForm.clearFormData()
        this.$refs.profitInfoForm.clearFormData()
        this.$refs.efsStlSettleDetailForm.clearFormData()

      },
      getAllTable() {
        return new Promise(resolve => {
          resolve([]);
        })
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter() {
        let fieldval = pick(this.model,'paCompanyCode','pbFarmerCode','code','name','cooperMode','conType','breedBatchCode','partyBSignDate','conStartDate','conEndDate','conAddress','conIndustry','conIndustryDepart','conReporter','conCurrency','conFunctionalCurrency','conDiscountRate','pbFarmerName','breedVarietyCode','breedClassCode','conServiceGroup')
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
          this.$refs.columnInfoForm.initFormData(this.url.efsStlSettleDetail.list,this.model.id)
          this.$refs.consumeInfoForm.initFormData(this.url.efsStlSettleDetail.list,this.model.id)
          this.$refs.profitInfoForm.initFormData(this.url.efsStlSettleDetail.list,this.model.id)
          this.$refs.efsStlSettleDetailForm.initFormData(this.url.efsStlSettleDetail.list,this.model.id)
        })
          this.initBreedClass(this.model.breedClassCode);
        // 加载子表数据
        if (this.model.id) {
          let params = { code: this.model.code }
          this.requestSubTableData(this.url.viewEfsStlSubsidy.list, params, this.viewEfsStlSubsidyTable)
          this.requestSubTableData(this.url.viewEfsStlFee.list, params, this.viewEfsStlFeeTable)
        }
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
          columnInfoList: this.$refs.columnInfoForm.getFormData(),
          consumeInfoList: this.$refs.consumeInfoForm.getFormData(),
          profitInfoList: this.$refs.profitInfoForm.getFormData(),
          efsStlSettleDetailList: this.$refs.efsStlSettleDetailForm.getFormData(),
        }
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          })
        }
      },
      validateError(msg){
        this.$message.error(msg)
      },
     popupCallback(row){
       this.form.setFieldsValue(pick(row,'paCompanyCode','pbFarmerCode','code','name','cooperMode','conType','breedBatchCode','partyBSignDate','conStartDate','conEndDate','conAddress','conIndustry','conIndustryDepart','conReporter','conCurrency','conFunctionalCurrency','conDiscountRate','pbFarmerName','breedVarietyCode','breedClassCode','conServiceGroup'))
     },
      conCodeChanged(param) {
        getAction(this.url.queryByConCode, { code: param }).then(res => {
          if (res.success) {
            this.form.resetFields()
            this.form.setFieldsValue({
              code: res.result.code,
              name: res.result.name,
              paCompanyCode:res.result.paCompanyCode,
              pbFarmerCode:res.result.pbFarmerCode,
              cooperMode: res.result.cooperMode,
              conType: res.result.conType,
              breedBatchCode: res.result.breedBatchCode,
              partyBSignDate: res.result.partyBSignDate,
              conStartDate: res.result.conStartDate,
              conEndDate: res.result.conEndDate,
              conAddress: res.result.conAddress,
              conIndustry: res.result.conIndustry,
              conIndustryDepart: res.result.conIndustryDepart,
              conReporter: res.result.conReporter,
              conCurrency: res.result.conCurrency,
              conFunctionalCurrency: res.result.conFunctionalCurrency,
              conDiscountRate: res.result.conDiscountRate,
              pbFarmerName: res.result.pbFarmerName,
              breedVarietyCode: res.result.breedVarietyCode,
              breedClassCode: res.result.breedClassCode,
              conServiceGroup: res.result.conServiceGroup,
            });
              this.dictBreedVarietyCode = "sys_category,name,code,pid=(select id from sys_category where code= '" + res.result.breedClassCode + "')";
          } else {
            this.$message.warning(res.message)
          }
        });
        getSettleByConCode({contractCode: param}).then((res) => {
          if (res.success) {
            this.conCodeList = res.result.newEfsMdContract;
          }
        });

      },
        initBreedClass(value){
            if(value){
                this.dictBreedVarietyCode = "sys_category,name,code,pid=(select id from sys_category where code= '" + value + "')";
            }else {
                this.dictBreedVarietyCode = "";
            }
        },
    }
  }
</script>

<style scoped>
</style>